"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var State = /** @class */ (function () {
    function State() {
        this.params = {
            adults: 2,
            juveniles: 0,
            children: 0,
            ship: null,
            // maxResults: null,
            // portID: null,
            regionID: null,
            timeFrom: null,
            timeTo: null,
            departureAirport: null,
            travelDuration: null,
            extraFilter: null,
        };
        this.backgroundImages = [];
        this.flights = {};
        this.searchResults = [];
        this.paramsTouched = false;
        this.searchButtonTouched = false;
        this.availableRegions = [];
        this.availableShips = [];
        this.availableAirports = [];
        this.availableDurations = [
            {
                id: 0,
                name: 'beliebig',
                from: 1,
                to: 9999,
            },
            {
                id: 1,
                name: '1-5 Tage',
                from: 1,
                to: 5,
            },
            {
                id: 6,
                name: '6-9 Tage',
                from: 6,
                to: 9,
            },
            {
                id: 10,
                name: '10-13 Tage',
                from: 10,
                to: 13,
            },
            {
                id: 14,
                name: '14-21 Tage',
                from: 14,
                to: 21,
            },
            {
                id: 22,
                name: 'ab 22 Tage',
                from: 22,
                to: 99999,
            },
        ];
        this.availableExtraFilters = [
            {
                id: 'SEL',
                name: 'AIDA Selection',
            },
            /* {
            id: 'ACT',
            name: 'AIDA Aktion',
          }, */
            {
                id: 'PAU',
                name: 'AIDA Pauschal',
            },
            {
                id: 'VAR',
                name: 'AIDA Vario',
            },
            {
                id: 'IND',
                name: 'AIDA Premium',
            },
            {
                id: 'FR',
                name: 'Frühbucherrabatt',
            },
            {
                id: 'AIR',
                name: 'inkl. Flug',
            },
            {
                id: 'DE',
                name: 'ab Deutschland',
            },
        ];
        this.reducedResultsFilter = [];
    }
    return State;
}());
exports.State = State;
//# sourceMappingURL=state.js.map